import { styled } from '@linaria/react'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const SearchAutocompleteItemSC = styled.div`
  display: flex;
  width: 100%;
  padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_40});
  align-items: center;
  gap: var(${FIXED_INDENTS.INDENT_40});
  cursor: pointer;

  ${MEDIA.MIN_600} {
    padding: var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_50});
  }

  ${MEDIA.MIN_1240} {
    padding: var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_60});
  }

  ${MEDIA.NO_TOUCH} {
    &[data-highlighted='true'] {
      background: var(${COLOR.SURFACE_OPACITY_LIGHT_10});
    }
  }
`
